/**
 * 回到顶部按钮
 */
import React, { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import "./index.less"

export function GoTop() {
  const [showGotop, setShowGoTop] = useState(false)

  const clickGoTop = () => {
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    window.onscroll = () => {
      let height = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop

      if (height > window.innerHeight) {
        setShowGoTop(true)
      } else {
        setShowGoTop(false)
      }
    }

    return () => {
      window.onscroll = null
    }
  })

  return ReactDOM.createPortal(
    <>
      {showGotop && (
        <div>
          <span className="topimg" onClick={clickGoTop}></span>
        </div>
      )}
    </>,document.body
  )
}
